/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Nikolay Sviridov
 * @version 1.33.0
 * @since 1.33.0
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../../theme';

export const WizardImportSubscribersLimitsStyled = styled.div.attrs({
    className: 'wizard-import-subscribers-limits',
})`
    margin-top: 32px;

    .wizard-import-subscribers-limits__text_bold {
        ${fonts.textMainBold};
    }

    .wizard-import-subscribers-limits__text_warning {
        ${fonts.textMainBold};
    }

    .wizard-import-subscribers-limits__text_error {
        color: ${colors.textColorDanger};
    }

    .wizard-import-subscribers-limits__export-errors {
        display: flex;
        justify-content: space-between;
        margin-bottom: 12px;
    }

`;
